import { render, staticRenderFns } from "./DefaultContentBlock.vue?vue&type=template&id=ebee5d08&scoped=true&"
import script from "./DefaultContentBlock.vue?vue&type=script&lang=js&"
export * from "./DefaultContentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebee5d08",
  null
  
)

export default component.exports